import React from 'react'
import { Button } from 'semantic-ui-react'
import { generatePDF } from '../../commonApis'

const PreviewPDFButton = (props) => {
  const toggleLoaderFunc = props.toggleLoaderFunc
  let pdfType = 'CLIENT_PDF_CDS_UK'
  let signDate = Date.now()

  const onButtonClick = async () => {
    const shipId = props.shipId
    toggleLoaderFunc(`Generating CDS document...`, 5000)
    const euPdfResult = generatePDF(shipId, pdfType, signDate)
    const pdfEu = await euPdfResult
    let pdfUrl = pdfEu?.data?.eventMessage?.url || ''
    props.handleFinalReviewClick(null, null, false, null, pdfUrl)
  }
  return (
    <Button
      id='previewpdfbutton'
      size='mini'
      key='PreviewPDF'
      className="sv todo-button secondaryBtn"
      onClick={() => {
        onButtonClick()
      }}
    >
      PREVIEW PDF
    </Button>
  )
}

export default PreviewPDFButton
